import { render, staticRenderFns } from "./ResellerListTable.vue?vue&type=template&id=3b73f13f&"
import script from "./ResellerListTable.vue?vue&type=script&lang=js&"
export * from "./ResellerListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports